export default "__VITE_ASSET__C3TebEM3__"